import {
  Component,
  ViewChild,
  OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RfpApplicantClarificationQueriesComponent } from "@/app/components/projects/project-requests/requested-tendering/requested-itt/rfp-applicant-clarification-wrapper/rfp-applicant-clarification-queries/rfp-applicant-clarification-queries.component";
import { RfpApplicantClarificationAddendumsComponent } from "@/app/components/projects/project-requests/requested-tendering/requested-itt/rfp-applicant-clarification-wrapper/rfp-applicant-clarification-addendums/rfp-applicant-clarification-addendums.component";
import { RfpApplicantClarificationCreateQueryComponent } from "@/app/components/projects/project-requests/requested-tendering/requested-itt/rfp-applicant-clarification-wrapper/rfp-applicant-clarification-create-query/rfp-applicant-clarification-create-query.component";
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
// import { RfpClarificationQueriesComponent } from "@/app/components/projects/project-development/tendering/inivitation-to-tender/itt-sender-side/Clarification/rfp-clarification-queries/rfp-clarification-queries.component";


@Component({
  selector: 'app-rfp-applicant-clarification-wrapper',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    RfpApplicantClarificationCreateQueryComponent,
    RfpApplicantClarificationQueriesComponent,
    RfpApplicantClarificationAddendumsComponent,
  ],
  templateUrl: './rfp-applicant-clarification-wrapper.component.html',
  styleUrl: './rfp-applicant-clarification-wrapper.component.css'
})
export class RfpApplicantClarificationWrapperComponent implements OnInit {
  @ViewChild(RfpApplicantClarificationQueriesComponent) rfpApplicantClarificationQueriesComponent!: RfpApplicantClarificationQueriesComponent;
  selectedSection: string = 'clarification';
  projectId: number;
  rfpId: number;

  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.projectId = params.get('projectId') ? parseInt(params.get('projectId')) : null;
      this.rfpId = params.get('rfpId') ? parseInt(params.get('rfpId')) : null;
    });
  }

  // Open questions modal
  openRFPApplicantCreateQueryDialog(): void {
    const dialogRef = this.dialog.open(RfpApplicantClarificationCreateQueryComponent, {
      width: '80vw',
      panelClass: 'custom-dialog-container',
      maxWidth: '80vw',
      maxHeight: '70vh',
      autoFocus: false, // Prevent automatic focus stealing
      disableClose: true, // Prevent closing on outside click
      data: {
        projectId: this.projectId,
        rfpId: this.rfpId,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result?.success) {
        this.rfpApplicantClarificationQueriesComponent.updateQueries()
      } else {
        console.warn('No valid approval found in the response:', result);
      }
    });
  }
}
